import { RxCollection, RxCollectionCreator, RxJsonSchema } from "rxdb"
import { ItemClass } from "src/util/types/dataModels/itemClass"

//region Types

export type ItemClassCollection = RxCollection<ItemClass>

//endregion

/**
 * Schema for item class collections
 */
export const itemClassSchema: RxJsonSchema<ItemClass> = {
  title: "Item class schema",
  description: "Item classes for a particular user",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    designation: { type: "string", maxLength: 100 },
    enable_model: { type: "boolean" },
    attributes_char_item: {
      type: "array",
      ref: "attribute_char",
      items: {
        type: "string",
      },
    },
    attributes_numeric_item: {
      type: "array",
      ref: "attribute_numeric",
      items: {
        type: "string",
      },
    },
    attributes_temporal_item: {
      type: "array",
      ref: "attribute_temporal",
      items: {
        type: "string",
      },
    },
    attributes_select_item: {
      type: "array",
      ref: "attribute_select",
      items: {
        type: "string",
      },
    },
    attributes_char_model: {
      type: "array",
      ref: "attribute_char",
      items: {
        type: "string",
      },
    },
    attributes_numeric_model: {
      type: "array",
      ref: "attribute_numeric",
      items: {
        type: "string",
      },
    },
    attributes_temporal_model: {
      type: "array",
      ref: "attribute_temporal",
      items: {
        type: "string",
      },
    },
    attributes_select_model: {
      type: "array",
      ref: "attribute_select",
      items: {
        type: "string",
      },
    },
    restricted_to_work_domains: {
      type: "array",
      items: {
        type: "string",
      },
    },
    restricted_to_procedures: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "designation"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const itemClassCollectionCreator: RxCollectionCreator = {
  schema: itemClassSchema,
}
